








































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { getJWTPayload } from "@/getinfo-api/auth";
import { Company as ICompany } from "@/api/models/company";
import { customMenu } from "@/menu";
import CopiedTestsQuestion from "@/components/tests/CopiedTestsQuestion.vue";
import WhatsNew from "@/components/home-page/WhatsNew.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import {
  studentLimitModule,
  switchFrontVersionModule
} from "@/plugins/modules-detect";
import LocalesMenu from "@/components/user/LocalesMenu.vue";
import StudentLimitSettingsHeader from "@/components/admin/StudentLimitSettingsHeader.vue";
import api, { settingStorageApi } from "@/getinfo-api";
import {
  getCurrentCompanyId,
  getCurrentEmployee,
  getCurrentUserId,
  isRoot
} from "@/plugins/roles";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { settingStorageLocalApi } from "@/getinfo-api/settingsStorage";
import ShareAccess from "@/components/admin/ShareAccess.vue";
import NotificationDropdown from "@/components/notification/NotificationDropdown.vue";

@Component({
  components: {
    NotificationDropdown,
    ShareAccess,
    CSingleSelect,
    StudentLimitSettingsHeader,
    LocalesMenu,
    CustomButton,
    WhatsNew,
    CopiedTestsQuestion
  }
})
export default class MainMenu extends Vue {
  showLeftSidePanel: boolean = false;
  showLearningMaterials: boolean = false;
  showEducationControl: boolean = false;
  showSales: boolean = false;
  showReports: boolean = false;
  showControlPanel: boolean = false;
  showSettings: boolean = false;
  showFixedAddMaterial: boolean = false;
  showFixedSettings: boolean = false;
  menuState!: string | null;
  selectedCompany!: ICompany;
  selectCompaniesList: boolean = true;
  studyDocuments: boolean = false;
  showAddMaterialMobile: boolean = false;
  action!: string;
  headerUniqId: string =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);
  menuUniqId: string =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);
  data() {
    return {
      action: "",
      menuState: null,
      selectedCompany: undefined
    };
  }

  toggleStateMenu() {
    this.showLeftSidePanel = !this.showLeftSidePanel;
    if (this.showLeftSidePanel) {
      this.menuState = "1";
      localStorage.setItem("menuState", "1");
    } else {
      this.menuState = "0";
      localStorage.setItem("menuState", "0");
    }
  }

  get isStudentLimitModule() {
    return studentLimitModule();
  }

  get isSwitchFrontModuleEnabled() {
    return switchFrontVersionModule();
  }

  protected get username(): string {
    const payload = getJWTPayload();
    if (payload) {
      return payload.username;
    } else {
      return "Undefined user";
    }
  }

  closeMenu() {
    this.showLeftSidePanel = false;
  }

  goTo() {
    if (this.screenWidth < 577) {
      this.showLeftSidePanel = false;
    }
  }

  goToMyProfile() {
    if (this.screenWidth < 577) {
      this.showLeftSidePanel = false;
    }
  }

  getShortCompanyTitle(title: string): string {
    if (title.length > 40) {
      title = title.slice(0, 40) + `...`;
    }
    return title;
  }

  closeMobile() {
    if (this.screenWidth <= 577 && this.showLeftSidePanel) {
      this.showLeftSidePanel = false;
      this.menuState = "0";
    }
  }

  async initStores() {
    await this.$store.state.user.user.init();
    await this.$store.dispatch("usersCompanies");
  }

  created() {
    this.initStores();
    // this.$store.dispatch("usersCompanies");
    if (localStorage.getItem("menuState")) {
      this.menuState = localStorage.getItem("menuState");
      if (this.menuState === "1") {
        this.showLeftSidePanel = true;
      }
    } else {
      localStorage.setItem("menuState", "1");
      this.menuState = "1";
    }
    if (this.screenWidth < 577) {
      this.showLeftSidePanel = false;
      this.menuState = "0";
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get allStoreCompanies() {
    return this.$store.getters.companiesList.filter(
      (el: ICompany) => el.enabled
    );
  }

  get storeSelectedCompany() {
    return this.$store.getters.selectedCompany;
  }

  get roles() {
    return this.$store.getters.roles;
  }

  get menuItem() {
    return customMenu();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get learningRequestManager() {
    return this.currentEmployee?.roles.includes("learning_request_manager");
  }

  get documentManager() {
    return this.currentEmployee?.roles.includes("document_manager");
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get root() {
    return isRoot();
  }

  get checkAccess() {
    return (
      this.companyOwner ||
      this.learningRequestManager ||
      this.documentManager ||
      this.contentManager ||
      this.root
    );
  }

  changeCookie() {
    document.cookie = "front_ver=2";
    // Без перезагрузки возникает проблема с кешом
    // window.location.href = `${window.location.origin}`;
    window.location.reload();
  }

  async getStudentLimit() {
    if (this.companyId) {
      settingStorageApi.Company.getCompanySettings(this.companyId, [
        "studentLimit"
      ]).then(res => {
        //@ts-ignore
        if (res.data[0].value?.amount) {
          //@ts-ignore
          this.$store.state.studentLimit = +res.data[0]?.value?.amount ?? 0;
        } else {
          this.$store.state.studentLimit = 0;
        }
      });
    }
  }
  async getStudentActive() {
    if (this.companyId) {
      api.CourseApi.listenersCountGlobal(this.companyId).then(res => {
        this.$store.state.studentAmount = +res.data;
      });
    }
  }

  getCompanyConfig() {
    if (this.companyId) {
      settingStorageApi.Company.getCompanySettings(this.companyId, [
        "companySettings"
      ]).then((res: { data: any }) => {
        if (res.data.length !== 0) {
          this.$store.state.companyUtils.companyDayOffs =
            res.data[0].value.companyDayOffs;
          this.$store.state.companyUtils.companyAmountWorkHrs =
            res.data[0].value.companyAmountWorkHrs;
        } else {
          settingStorageApi.Company.putCompanySettings(this.companyId, [
            {
              name: "companySettings",
              value: {
                companyAmountWorkHrs: 8,
                companyDayOffs: [0, 6]
              }
            }
          ]).then((res: { data: any }) => {
            if (res.data.length !== 0) {
              this.$store.state.companyUtils.companyDayOffs =
                res.data[0].value.companyDayOffs;
              this.$store.state.companyUtils.companyAmountWorkHrs =
                res.data[0].value.companyAmountWorkHrs;
            }
          });
        }
      });
    }
  }

  get currentUser() {
    return getCurrentUserId();
  }

  get isMobile() {
    return this.screenWidth <= 577;
  }

  @Watch("selectedCompany")
  selectCompanyUpdate() {
    this.$store.dispatch("selectCompany", this.selectedCompany);
    this.$store.dispatch("getRolesInCompany", this.selectedCompany);
    settingStorageLocalApi.User.setUserCompany(
      this.currentUser,
      this.selectedCompany.id
    );
    this.getCompanyConfig();
    if (this.isStudentLimitModule) {
      this.getStudentActive();
      this.getStudentLimit();
    }

    if (this.screenWidth < 577) {
      this.showLeftSidePanel = false;
    }
  }

  @Watch("storeSelectedCompany")
  updateCompany() {
    this.selectedCompany = this.storeSelectedCompany;
  }

  @Watch("$route")
  closeFixedMenu() {
    this.showFixedAddMaterial = false;
    this.showFixedSettings = false;
  }
}
